<review-display [review]="review" [showTitle]="showTitle">
  @if (review.visitedFrom) {
    <div>Visited {{review.visitedFrom | date: 'MMM y'}}</div>
  }
</review-display>